import { Button } from "@mui/material";
import React, { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import TokenService from "../../../api/token.service";
import AuthContext from "../../../context/user-auth/AuthProvider";
import BlockLoader from "../../blockloader/BlockLoader";
import "./AuthVerficationOtp.modules.css";

function AuthVerficationOtp(props) {
  const [isLoading, setIsLoading] = useState(false);
  const { verifyUserOtp, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || "/";
  const [otp, setOtp] = useState(new Array(6).fill(""));

  const handleSubmit = async (event) => {
    setIsLoading(true);
    const response = await verifyUserOtp({
      id: window.$userId,
      otp: parseInt(otp.join("")),
    });

    if (response.data.success && response.data.message === "Login Successfull") {
      const accessToken = response.data.data.token;

      TokenService.setUser(accessToken);
      dispatch({ type: "LOGIN_SUCCESS", payload: accessToken });
      props.onHide();
      navigate(from, { replace: true });
    } else {
      setIsLoading(false);
    }
  };

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

    //Focus next input
    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };
 

  return (
    <Modal {...props} backdrop="static" keyboard={false} aria-labelledby="contained-modal-title-vcenter" centered>
      {isLoading && <BlockLoader position="absolute" />}
      <Modal.Header closeButton body-text-variant="--bs-purple">
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="text-center">
            <h6>Enter the 6-digit authentication code sent to your email id.</h6>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mybox">
          <div className="row">
            <div className="col text-center">
              {otp.map((data, index) => {
                return <input className="otp-field form-control" type="text" name="otp" maxLength="1" value={data} onChange={(e) => handleChange(e.target, index)} onFocus={(e) => e.target.select()} />;
              })}
            </div>
            <div className="text-center mt-2">
              <Button variant="contained" className="me-2" onClick={(e) => setOtp([...otp.map((v) => "")])}>
                Clear
              </Button>
              <Button variant="contained" color="error" onClick={() => handleSubmit()}>
                Verify OTP
              </Button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AuthVerficationOtp;
